import { Label } from "@/components/ui/label";

export const Field = ({ label, children, className = "", hint }) => (
  <div className={`space-y-1.5 ${className}`}>
    <Label className="text-[11px] uppercase tracking-[0.12em] font-semibold text-[#0D3B52]">{label}</Label>
    {children}
    {hint && <p className="text-xs text-[#5C6B73]">{hint}</p>}
  </div>
);

export const NativeSelect = ({ className = "", children, ...p }) => (
  <select
    className={`flex h-10 w-full rounded-md border border-[#E2DDD5] bg-white px-3 text-sm text-[#1C2A33] focus:outline-none focus:ring-2 focus:ring-[#0D3B52] ${className}`}
    {...p}
  >
    {children}
  </select>
);

export const Pill = ({ cls = "", children, ...p }) => (
  <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${cls}`} {...p}>
    {children}
  </span>
);

export const PageHead = ({ eyebrow, title, subtitle, children }) => (
  <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between mb-8 rise">
    <div>
      {eyebrow && <p className="text-[11px] uppercase tracking-[0.2em] text-[#997316] font-semibold mb-2">{eyebrow}</p>}
      <h1 className="font-display text-3xl sm:text-4xl font-semibold text-[#0D3B52] leading-tight">{title}</h1>
      {subtitle && <p className="text-sm text-[#5C6B73] mt-2 max-w-2xl">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const StatCard = ({ label, value, icon: Icon, tone = "navy", testid }) => (
  <div className="rounded-2xl border border-[#E2DDD5] bg-white p-6 relative overflow-hidden transition-transform duration-300 hover:-translate-y-0.5">
    <div className={`absolute -right-6 -top-6 h-20 w-20 rounded-full ${tone === "gold" ? "bg-[#F4E8C1]" : "bg-[#0D3B52]/5"}`} />
    <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.14em] text-[#5C6B73] font-semibold">
      {Icon && <Icon className="h-4 w-4 text-[#B8860B]" />}
      {label}
    </div>
    <p data-testid={testid} className="font-display text-3xl font-semibold text-[#0D3B52] mt-3">{value}</p>
  </div>
);

export const Empty = ({ children }) => (
  <div className="rounded-2xl border border-dashed border-[#E2DDD5] bg-white/60 p-10 text-center text-sm text-[#5C6B73]">
    {children}
  </div>
);

export const Card = ({ className = "", children, ...p }) => (
  <div className={`rounded-2xl border border-[#E2DDD5] bg-white ${className}`} {...p}>{children}</div>
);
